import requests from '../../../../redux/reducer/requests';
import content from '../../../../redux/reducer/content';
import { useDispatch } from 'react-redux';

export default function useQuizCallbacks() {
  const dispatch = useDispatch();

  return {
    getCurrentQuiz: () => dispatch(requests.thunks.getCurrentQuiz()),
    submitCurrentQuizResult: (data) => dispatch(requests.thunks.submitCurrentQuizResult(data)),
    getQuizQuests: () => dispatch(requests.thunks.getQuizQuests()),
    submitQuizQuest: (data) => dispatch(requests.thunks.submitQuizQuest(data)),
    buyQuiz: () => dispatch(requests.thunks.buyQuiz()),
    setActiveQuizQuests: (uid) => dispatch(content.actions.setActiveQuizQuests(uid)),
    setActiveQuizQuest: (quest) => dispatch(content.actions.setActiveQuizQuest(quest)),
    setActiveWinners: (data) => dispatch(content.actions.setActiveWinners(data)),
  };
}
